import { Box, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";

import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { useElementTableData } from "./hooks/useElementTableData";
import { useElementStyles } from "./styles/useElementStyles";

export const ElementTable = () => {
	const commonTableClasses = useTableStyles();
	const localClasses = useElementStyles();
	const { state } = useCastersContext();

	const elementList = state.elements || [];

	const { columns, rowData, getRowStyle } = useElementTableData({
		elementList,
	});

	const gridHeight = 20 + rowData.length * 45 + 2;
	const minHeight = 190;

	return (
		<>
			<Paper className={commonTableClasses.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div
						className={`${commonTableClasses.materialTable}`}
						style={{
							height: `${Math.max(gridHeight, minHeight)}px`,
							minWidth: "100%",
						}}
					>
						<AgGridReact
							rowData={rowData}
							columnDefs={columns}
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							suppressContextMenu
							getRowId={(params) => params.data.id}
							getRowStyle={getRowStyle}
							noRowsOverlayComponent={() => "No chemistry data available"}
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
